import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">网友热议</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">来看看吃瓜群众们都在聊什么</p>
        </div>

        <div className="space-y-4">
          {commentItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl p-5 border border-background-200/60">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900">{item.name}</span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{item.content}</p>
                  <div className="flex items-center gap-4 mt-3">
                    <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-500 transition-colors">
                      <i className="ri-thumb-up-line"></i>
                      <span>{item.likes}</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-500 transition-colors">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}